export default {
  colors: {
    background: '#000000',
    text: '#ffffff',

    white: '#ffffff',
    black: '#000000',

    yellow: '#FFDF22',
    red_linear_gradient: 'linear-gradient(99deg, #D90606 0%, #F11B1B 100%)',
    black_linear_gradient: 'linear-gradient(99deg, #000000 0%, #232323 100%)',
    yellow_linear_gradient: 'linear-gradient(107deg, #FFD503 0%, #FFDF22 100%)',
    yellow_linear_gradient2: 'linear-gradient(98deg, #FFD503 0%, #FFDF22 100%)',
    yellow_linear_gradient3:
      'linear-gradient(268deg, #FFD503 0%, #FFDF22 100%)',
  },
  fontWeight: {
    LatoThin: 100,
    LatoLight: 300,
    LatoRegular: 400,
    LatoBold: 700,
    LatoBlack: 900,
  },
  fontFamily: {
    Lato: 'Lato, sans-serif',
    Nunito: 'Nunito, sans-serif',
  },
  transition: {
    default: '180ms ease-in',
  },
};
